import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import Page from 'components/Page';
import globalMessages from 'translations/messages';
import { GLOBAL_SETTINGS, SURVEY_TEMPLATE_SETTINGS } from 'shared/constants/settings';
import SettingsList from 'components/Settings/SettingsList';
import { Button } from 'antd';
import SettingsDrawer from 'components/Settings/SettingsDrawer';
import { EditOutlined } from '@ant-design/icons';

const GlobalSettings = () => {
  const [edit, setEdit] = useState(false);

  return (
    <Page>
      <Page.Header
        title="Global settings"
        extra={(
          <Button type="primary" onClick={() => setEdit(true)} icon={<EditOutlined />}>
            <FormattedMessage {...globalMessages.edit} />
          </Button>
      )}
      />
      <Page.Content>
        <SettingsList settings={{ ...GLOBAL_SETTINGS, ...SURVEY_TEMPLATE_SETTINGS }} relationId={null} refresh={!edit} />
        <SettingsDrawer settings={{ ...GLOBAL_SETTINGS, ...SURVEY_TEMPLATE_SETTINGS }} relationId={null} open={edit} onDone={() => setEdit(false)} onCancel={() => setEdit(false)} />
      </Page.Content>
    </Page>
  );
};

export default GlobalSettings;
